import { memo } from 'react';

import { FileStatusIconProgressing, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { type AssetBoardMembershipUpdateOperation } from '~/components/AssetBoardMembershipUpdateTasks/assetBoardMembershipUpdateTaskPanelTypes';
import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type AssetBoardMembershipUpdateTaskInProgressPanelItemProps = {
  onClear: () => void;
  operation: AssetBoardMembershipUpdateOperation;
};

export const AssetBoardMembershipUpdateTaskInProgressPanelItem = memo(
  ({ onClear, operation }: AssetBoardMembershipUpdateTaskInProgressPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();
    const isAdd = operation === 'add';
    const inProgressTitle = isAdd ? 'Adding assets' : 'Moving assets';

    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={
          <FileStatusTitle data-testid="ASSET_BOARD_MEMBERSHIP_UPDATE_TASK_IN_PROGRESS_TITLE">
            {ui2026 ? `${inProgressTitle}…` : inProgressTitle}
          </FileStatusTitle>
        }
        subtitle={ui2026 ? undefined : <FileStatusSubtitle>Your assets will be updated shortly.</FileStatusSubtitle>}
        buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
      />
    );
  },
);

AssetBoardMembershipUpdateTaskInProgressPanelItem.displayName = 'AssetBoardMembershipUpdateTaskInProgressPanelItem';
